import { render, staticRenderFns } from "./ContractDetails.vue?vue&type=template&id=de5646f4&scoped=true&"
import script from "./ContractDetails.vue?vue&type=script&lang=js&"
export * from "./ContractDetails.vue?vue&type=script&lang=js&"
import style0 from "./ContractDetails.vue?vue&type=style&index=0&id=de5646f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de5646f4",
  null
  
)

export default component.exports